
export const baseUri = process.env.REACT_APP_API_BASE_URL;
export const s3baseUri = process.env.REACT_APP_PIC_BASE_URL;
export const client_url = process.env.REACT_APP_CLIENT_URL;
export const xshKey = process.env.REACT_APP_SSH_KEY;
export const project_mode = process.env.REACT_APP_PROJECT_MODE;
export const website_url = process.env.REACT_APP_WEBSITE_URL;
